export function getColumnHeaderClass(sortDirectionCssClasses, calc) {
    let headerClass = '';
    const sortClass = sortDirectionCssClasses[calc.metricInternalName];
    if (sortClass && sortClass['th-sort-asc']) {
        headerClass += 'th-sort-asc ';
    }
    else if (sortClass && sortClass['th-sort-desc']) {
        headerClass += 'th-sort-desc ';
    }
    if (calc.headerClass === undefined) {
        headerClass += 'text-right';
    }
    else {
        headerClass += calc.headerClass;
    }
    return headerClass;
}
